// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"299":"165a18fe","325":"165a18fe","864":"f5d3f5b9"}[chunkId] + ".chunk.css";
};